export default "/images/vendor/flag-icon-css/flags/1x1/fm.svg?1579e5b6f7e79e7514451b61b5acd1e0";